export enum CandidUrl {
  Production = 'https://app.joincandidhealth.com',
  Staging = 'https://app-staging.joincandidhealth.com'
}

export enum CandidOrgId {
  Production = '4bb54d17-969d-4442-85f7-e8355ba150eb',
  Staging = 'a4d03d9d-0b7a-47fc-84d3-b3cc544f1dc1'
}
